module.exports = __webpack_public_path__ + "img/credit-card-2-back-fill.2626f477.svg";